module.exports = __webpack_public_path__ + "static/about-us-02-8c2dc3b3e82585e86a70814761a0804e.jpg";